import type { Ref } from 'react';
import { cn } from '~/utils';

type LabeledCheckboxProps = {
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  readonly label: string;
  readonly ariaLabel?: string;
  readonly disabled?: boolean;
  readonly testId?: string;
  readonly className?: string;
  readonly ref?: Ref<HTMLInputElement>;
};

export function LabeledCheckbox({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled = false,
  testId,
  className,
  ref,
}: LabeledCheckboxProps) {
  return (
    <label
      className={cn(
        'flex items-center gap-1.5',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(event) => onChange(event.target.checked)}
        className="h-4 w-4 cursor-pointer accent-prim disabled:cursor-not-allowed disabled:opacity-50"
        data-testid={testId}
      />
      <span className="text-xs text-neut-500">{label}</span>
    </label>
  );
}
